//
import moment from 'moment'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import CurrencyUtils from '@/mixins/reusable_mixins/CurrencyUtils'

//
import CustomerReceivablePaymentModel from '@/models/POS/PosCustomerReceivablePayment'
import BankModel from '@/models/General/GBank'
/**
 *
 */
const appends = ['transformed_payments']

/**
 *
 */
const includes = [
    'pos_cash_desk.g_branch_office',
    'g_user.hr_employee',
    'sl_ground_seller_payment_record.sl_ground_seller.hr_employee',
    'sl_ground_seller_payment_record.sl_customer.pch_payment_condition',
    'sl_ground_seller_payment_record.sl_customer.sl_customer_account',
    'sl_ground_seller_payment_record.sl_detail_ground_seller_payment_records.sl_customer_account_receivable.sl_sale_invoice',
    'sl_customer.sl_customer_account',
    'sl_customer.sl_ground_seller.hr_employee.g_user',
    'pos_detail_customer_receivable_payments.sl_customer_account_movement.sl_type_customer_account_movement',
    'pos_detail_customer_receivable_payments.sl_customer_receivable.sl_sale_invoice',
    'pos_detail_customer_receivable_payments.sl_customer_receivable.sl_sale_debit_note',
    'payments',
]

const fetchBank = async function() {
    return (await BankModel.params({
        get_all_results: true,
    }).get()).data
}

const searchBankName = function(arr, id) {
    let bank = arr.find(r => r.id === id)
    return bank.bank
}

const getTypeCheck = function(id) {
    if (id === 1) {
        return 'Cheque a Fecha'
    }
    return 'Cheque al día'
}

/**
 * Retorna la fecha de pago de una transacción si esta existe en el objeto de 
 * retornado por la API, y si es un cheque, retorna "Al dia", en caso que la 
 * fecha de cargo sea nula.
 * @param   {*} payload -   transacción de pago retornada por la API 
 * @return  {*}             Fecha de la transacción, o "Al dia" si es "Cheque"
 */
function setPaymentChargeDate(payload) {

    // required
    let hasPivotCharge  = payload.pivot && payload.pivot.data && payload.pivot.data.charge_date
    let isCheck         = payload.type === "Cheque"
    let res             = isCheck ? 'Al dia' : ''

    // result
    if (hasPivotCharge) {
        return moment(payload.pivot.data.charge_date).format('D/MM/YYYY')
    }
    return res
}

const setSerialNumber = function(data, arrPayments=[]) {
    if (data.serial_number) {
        return data.serial_number
    } else if (data.voucher_number) {
        return data.voucher_number
    }
    else if ( data.sl_sale_credit_note_id && arrPayments.length>0) {
        let creditNotePayment = arrPayments.filter(arrP=>{
            if(arrP.paymentDetail.sl_sale_credit_note_id === data.sl_sale_credit_note_id) {
                return arrP
            }
        })
        return creditNotePayment[0].paymentDetail.number
    }
    return ''
}

const setChargeDate = function(date) {
    if (date) {
        return moment(date).format('D/MM/YYYY')
    } else {
        return moment().format('D/MM/YYYY')
    }
}

/**
 *
 */
export default async (id, arrInvoices, roundingLaw, totalPayed,arrPayments=[], copies = 1) => {
    let banks = await fetchBank()
    let body4Height = 0
    console.log(banks, 'bancos')
    //
    const customerReceivablePayment = await CustomerReceivablePaymentModel.include(
            ...includes
        )
            .append(...appends)
            .find(id),
        paymentVerifyId = customerReceivablePayment.id || '',
        receivablePaymentBusinessName =
            customerReceivablePayment.sl_customer.business_name || '',
        receivablePaymentCreated = customerReceivablePayment.created_at || '',
        receivablePaymentInvoices =
            customerReceivablePayment.pos_detail_customer_receivable_payments ||
            [],
        receivablePaymentRut = customerReceivablePayment.sl_customer.rut || '',
        receivablePayments = customerReceivablePayment.transformed_payments || [],
        body1Height = receivablePaymentInvoices.length * 15,
        body2Height = receivablePayments.length * 15,
        signHeight = 200
    
    //
    console.log(body1Height, body2Height, signHeight)

    //
    var doc = new jsPDF({ putOnlyUsedFonts: true, format: 'letter' }),
        body = [], //facturas
        body2 = [], //pagos
        body3 = [], //rounding
        body4 = [] //detalle

    receivablePaymentInvoices.forEach(invoice => {
        body.push([
            {
                colSpan: 1,
                content: invoice.sl_customer_receivable.sl_sale_invoice
                    ? 'FACTURA'
                    : invoice.sl_customer_receivable.sl_sale_debit_note
                        ? 'NOTA DE DÉBITO'
                        : '',
            },
            {
                colSpan: 1,
                content: 
                    invoice.sl_customer_receivable.sl_sale_invoice ? 
                    invoice.sl_customer_receivable.sl_sale_invoice.number
                    : 
                    invoice.sl_customer_receivable.sl_sale_debit_note ? 
                    invoice.sl_customer_receivable.sl_sale_debit_note.number 
                    : 
                    '',
            },
            CurrencyUtils.filters.mixFormatCurrency(
                invoice.sl_customer_receivable.amount
            ),
            CurrencyUtils.filters.mixFormatCurrency(
                invoice.sl_customer_receivable.paid_amount
            ),
            CurrencyUtils.filters.mixFormatCurrency(
                invoice.sl_customer_receivable.amount -
                    invoice.sl_customer_receivable.paid_amount
            ),
        ])
    })
    //
    receivablePayments.forEach(payment => {
        let data = payment.pivot.data
        if (payment.type == 'Cheque') {
            body4.push([
                getTypeCheck(data.pos_payment_check_type_id),
                searchBankName(banks, data.g_bank_id),
                data.account_number,
                data.serial_number,
                setChargeDate(data.charge_date),
                CurrencyUtils.filters.mixFormatCurrency(payment.pivot.amount),
            ])
            body4Height += 30
        }

        body2.push([
            payment.type,
            // moment(payment.created_at).format('D/MM/YYYY'),
            setPaymentChargeDate(payment),
            setSerialNumber(data, arrPayments),
            CurrencyUtils.filters.mixFormatCurrency(payment.pivot.amount),
        ])
    })

    if (roundingLaw != 0) {
        body3.push(['Ley redondeo', '$ ' + roundingLaw])
    }

    for(var i = 0; i < copies; i++){

        //
        //doc.setFontStyle('bold')
        doc.text('COMPROBANTE DE PAGO', 16, 20)
        //doc.setTextColor('#087f23')
        doc.text('# ' + paymentVerifyId, 16, 28)
        doc.setFontSize(12)
        doc.setFontStyle('normal')
        doc.setTextColor('#000')

        //
        doc.text('RUT DEL CLIENTE:', 16, 42)
        //doc.setFontStyle('bold')
        doc.text(receivablePaymentRut, 56, 42)
        doc.setFontStyle('normal')

        //
        doc.text('FECHA:', 152, 42)
        //doc.setFontStyle('bold')
        doc.text(moment(receivablePaymentCreated).format('D/MM/YYYY'), 170, 42)
        doc.setFontStyle('normal')

        //
        doc.text('NOMBRE DEL CLIENTE:', 16, 50)
        //doc.setFontStyle('bold')
        doc.text(receivablePaymentBusinessName, 66, 50)
        doc.setFontStyle('normal')

        //
        //doc.text( 'CÓDIGO DE CLIENTE:', 200, 50 )
        //doc.setFontStyle( 'bold' )
        //doc.text( paymentVerifyRut, 247, 50 )
        //doc.setFontStyle( 'normal' )

        //
        //doc.text( 'EFECTIVO $', 16, 58 )
        //doc.setFontStyle( 'bold' )
        //doc.text( paymentVerifyAmount, 44, 58 )
        //doc.setFontStyle( 'normal' )

        //
        doc.autoTable({
            head: [
                [{ colSpan: 3, content: 'DETALLE DE DOCUMENTOS A CANCELAR' }],
                [
                    'TIPO DOC',
                    'N° DE DOC',
                    { content: 'TOTAL FACTURA', halign: 'right' },
                    { content: 'DEUDA', halign: 'right' },
                    { content: 'SALDO', halign: 'right' },
                ],
            ],
            columnStyles: {
                0: { cellWidth: 20 },
                0: { cellWidth: 20 },
                1: { cellWidth: 20, halign: 'right' },
                2: { cellWidth: 20, halign: 'right' },
                3: { cellWidth: 20, halign: 'right' },
            },
            headStyles: {
                fillColor: '#fff',
                fontSize: 12,
                //fontStyle: 'bold',
                lineWidth: 0.25,
                textColor: '#000',
            },
            body: body,
            bodyStyles: {
                fontSize: 12,
                textColor: '#000',
            },
            theme: 'grid',
            startX: 66,
            startY: 62,
        })

        //
        doc.autoTable({
            head: [
                [{ colSpan: 2, content: 'DETALLE DE PAGOS REALIZADOS' }],
                [
                    'TIPO',
                    'FECHA',
                    'FOLIO',
                    { content: 'MONTO PAGADO', halign: 'right' },
                ],
            ],
            columnStyles: {
                0: { cellWidth: 30 },
                1: { cellWidth: 20 },
                2: { cellWidth: 20 },
                3: { cellWidth: 20, halign: 'right' },
            },
            headStyles: {
                fillColor: '#fff',
                fontSize: 12,
                fontStyle: 'normal',
                //lineColor: '#2196F3',
                lineWidth: 0.25,
                textColor: '#000',
            },
            body: body2,
            bodyStyles: {
                fontSize: 12,
                textColor: '#000',
            },
            theme: 'grid',
            startX: 66,
            startY: 66 + body1Height + 16,
        })

        doc.autoTable({
            head: [],
            columnStyles: {
                0: { cellWidth: 70 },
                1: { cellWidth: 30, halign: 'right' },
            },
            headStyles: {
                fillColor: '#fff',
                fontSize: 12,
                fontStyle: 'normal',
                //lineColor: '#2196F3',
                lineWidth: 0.25,
                textColor: '#000',
            },
            body: body3,
            bodyStyles: {
                fontSize: 12,
                textColor: '#000',
            },
            theme: 'grid',
            startX: 66,
            startY: 66 + body1Height + body2Height + 32,
        })

        if(body4.length >0){

            doc.autoTable({
                head: [
                    [{ colSpan: 2, content: 'DETALLE PAGO CON CHEQUE' }],
                    [
                        'TIPO',
                        'BANCO',
                        'CUENTA',
                        'N Documento',
                        'Fecha Pago',
                        { content: 'MONTO PAGADO', halign: 'right' },
                    ],
                ],
                columnStyles: {
                    0: { cellWidth: 20 },
                    1: { cellWidth: 20 },
                    2: { cellWidth: 20 },
                    3: { cellWidth: 10 },
                    4: { cellWidth: 10 },
                    5: { cellWidth: 20, halign: 'right' },
                },
                headStyles: {
                    fillColor: '#fff',
                    fontSize: 12,
                    fontStyle: 'normal',
                    //lineColor: '#2196F3',
                    lineWidth: 0.25,
                    textColor: '#000',
                },
                body: body4,
                bodyStyles: {
                    fontSize: 12,
                    textColor: '#000',
                },
                theme: 'grid',
                startX: 66,
                startY: 66 + body1Height + body2Height + 32,
            })
        }

        //
        doc.setFontStyle('bold')
        doc.text('FIRMA Y TIMBRE', 140, 66 + body1Height + body2Height + body4Height + 48) 

        if ((i + 1) < copies) doc.addPage();
    }

    //
    doc.save(['comprobante-pago-' + id + '.pdf'].join(''))
}
